import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { ParkingService } from '../../shared/services/parking.service';
import { STATUS_ERROR_EXTERNAL } from '../../core/constants/const';
import { FlashMessagesService } from '../../shared/services/flash-messages.service';
import { MessagesPipe } from '../../shared/pipes/messages.pipe';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Component({
  selector: 'app-parking-occupation',
  templateUrl: './parking-occupation.component.html',
  styleUrls: ['./parking-occupation.component.scss'],
})
export class ParkingOccupationComponent implements OnInit {
  @ViewChild('defaultOpen', null) defaultTab: ElementRef;
  nNormalBuildingA: number;
  nNormalBuildingB: number;
  nElectricBuildingA: number;
  nElectricBuildingB: number;
  messagesPipe = new MessagesPipe();
  token: string;
  language: string;
  edificioA: string;
  edificioB: string;
  perfilHorario: string;
  plazasLibres: string;

  // Data
  public lineChartData: ChartDataSets[] = [];

  // Axis X
  public lineChartLabels: Label[] = [];

  // Chart Options
  public lineChartOptions: ChartOptions & { annotation: any } = {
    responsive: true,
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      xAxes: [{}],
      yAxes: [
        {
          id: 'y-axis-0',
          position: 'left',
        },
      ],
    },
    annotation: {
      annotations: [
        {
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
        },
      ],
    },
    title: {
      text: '',
      fontSize: 20,
      fontColor: 'rgba(0,0,0,1)',
      display: true,
    },
    legend: {
      position: 'bottom',
    },
  };

  // Colors of the lines
  public lineChartColors: Color[] = [
    {
      borderColor: '#f58418',
    },
    {
      borderColor: '#5283c8',
    },
  ];

  public lineChartLegend = true;
  public lineChartType = 'line';

  constructor(
    private parkingService: ParkingService,
    private flashMessagesService: FlashMessagesService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    const queryParams = this.route.snapshot.queryParamMap;
    this.token = queryParams.get('access_token')
      ? queryParams.get('access_token')
      : this.authenticationService.getCurrentUser().accessToken;
    this.language = queryParams.get('language');
    if (this.language == null) {
      this.language = localStorage.getItem('language_app')
        ? localStorage.getItem('language_app')
        : navigator.language;
    } else {
      const idioma = this.language.toLowerCase();
      switch (idioma) {
        case 'es':
          this.language = 'es';

          this.messagesPipe.setLanguage(this.language);
          break;

        case 'en':
          this.language = 'en';
          this.messagesPipe.setLanguage(this.language);

          break;

        case 'pt':
          this.language = 'pt';
          this.messagesPipe.setLanguage(this.language);
          break;

        default:
          this.language = localStorage.getItem('language_app')
            ? localStorage.getItem('language_app')
            : navigator.language;
          break;
      }
    }
    this.edificioA = this.messagesPipe.transform(
      'parking_occupation_building_a'
    );
    this.edificioB = this.messagesPipe.transform(
      'parking_occupation_building_b'
    );
    this.perfilHorario = this.messagesPipe.transform(
      'parking_occupation_schedule'
    );
    this.plazasLibres = this.messagesPipe.transform(
      'parking_occupation_free_places'
    );

    this.defaultTab.nativeElement.click();
    this.getParkingOccupationBuildingA(1);
    this.getParkingOccupationBuildingB(2);
    this.getParkingOccupationHistoric(1);
  }

  getParkingOccupationBuildingA(id: any) {
    this.parkingService
      .getParkingOccupation(id, this.token)
      .subscribe((res) => {
        if (res) {
          this.nNormalBuildingA = res.normal;
          this.nElectricBuildingA = res.electric;
        }
      });
  }

  getParkingOccupationBuildingB(id: any) {
    this.parkingService.getParkingOccupation(id, this.token).subscribe(
      (res) => {
        if (res) {
          this.nNormalBuildingB = res.normal;
          this.nElectricBuildingB = res.electric;
        }
      },
      (error) => {
        if (error.code === STATUS_ERROR_EXTERNAL) {
          this.flashMessagesService.grayOut(false);
          this.flashMessagesService.show(
            this.messagesPipe.transform('parking_occupation_external_error'),
            {
              cssClass: 'alert-danger',
              timeout: 3000,
            }
          );
        }
      }
    );
  }

  getParkingOccupationHistoric(id: any) {
    this.parkingService.getParkingOccupationHistoric(id, this.token).subscribe(
      (res) => {
        if (res) {
          this.lineChartLabels = res.labels ? res.labels : '';
          this.lineChartData = [
            {
              data: res.normalValues ? res.normalValues : '',
              label: this.messagesPipe.transform(
                'parking_occupation_normal_parking'
              ),
            },
            {
              data: res.electricValues ? res.electricValues : '',
              label: this.messagesPipe.transform(
                'parking_occupation_electric_parking'
              ),
            },
          ];
        }
      },
      (error) => {
        if (error.code === STATUS_ERROR_EXTERNAL) {
          this.flashMessagesService.grayOut(false);
          this.flashMessagesService.show(
            this.messagesPipe.transform('parking_occupation_external_error'),
            {
              cssClass: 'alert-danger',
              timeout: 3000,
            }
          );
        }
      }
    );
  }

  manageTabs(evt: any, building: number) {
    let i: number, tablinks: any;

    tablinks = document.getElementsByClassName('tablinks');
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(' active', '');
    }

    evt.currentTarget.className += ' active';

    this.getParkingOccupationHistoric(building);
  }
}
